export const HOME_PATH = "/";
export const GET_TEST_PATH = "/get-test";
export const TEST_RESULTS_PATH = "/test-results";
export const TEST_ON_THE_WAY_PATH = "/test-on-way";
export const CHANGE_PASSWORD_PATH = "/choose-new-password/:uid/:token";
export const LOGIN_PATH = "/login";
export const CHECK_EMAIL_PATH = "/login/email-check";
export const ACCOUNT_PATH = "/account";
export const ABOUT_US_PATH = "/our-story";